import { Container, Row, Col } from "react-bootstrap";
import { useState, useEffect } from "react";
import { FaSun, FaMoon } from "react-icons/fa"; // Import icons from react-icons

export const Footer = ({ language }) => {
    const [isBlackBg, setIsBlackBg] = useState(true);

    const toggleBackground = () => {
        setIsBlackBg(prevIsBlackBg => !prevIsBlackBg);
    };

    useEffect(() => {
        const bodyElement = document.querySelector('body');
        bodyElement.classList.remove('black-bg', 'white-bg');
        bodyElement.classList.add(isBlackBg ? 'black-bg' : 'white-bg');
    }, [isBlackBg]);

    return (
        <footer className="footer">
            <Container>
                <Row className="align-items-center">
                    <Col size={6} sm={7} className="text-center text-sm-end">
                        <button onClick={toggleBackground} className="bg-toggle-button">
                            {isBlackBg ? <FaSun size={0.5} color="#FFD700" /> : <FaMoon size={0.5} color="#1E1E1E" />}
                            {/* Toggle between sun and moon icon */}
                        </button>
                        <p className="palace-script-Footer">©opyright 2025. All Rights Reserved</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};
